import React from 'react'
import { connect } from 'react-redux'
import { store } from '../../../store/index'

import Search from 'components/Search'
import Button from 'components/Button'
import ModalAddUsersToGroup from 'components/Groups/Modals/ModalAddUsersToGroup'

import { SETTINGS_PAGINATION, MODAL_ALERT_TYPES, CONFIG_BASE_URL } from 'utils/consts'
import actions from 'store/actions'

import closeBtn from 'assets/images/close.svg'
import noImage from 'assets/images/no-image.svg'

class ModalGroupInfo extends React.Component {
  state = {
    searchInputValue: '',
    selectedUsers: new Set(),
    isOpenModalAddUsersToGroup: false,

    isAllChecked: false,
  }

  /**
   * @param {String} searchInputValue
   */
  onChangeSearch = searchInputValue => {
    this.setState({ searchInputValue })
  }

  changeVisibillityModalAddUsersToGroup = () => {
    this.setState(prevState => ({
      isOpenModalAddUsersToGroup: !prevState.isOpenModalAddUsersToGroup,
    }))
  }

  /**
   * @param {Object} e
   */
  toggleUser = e => {
    const userID = parseInt(e.target.value)
    const { selectedUsers } = this.state

    if (selectedUsers.has(userID)) {
      selectedUsers.delete(userID)
    } else {
      selectedUsers.add(userID)
    }
    this.setState({ selectedUsers, isAllChecked: false })
  }

  toggleAllUsers = () => {
    const { selectedUsers, isAllChecked } = this.state

    if (isAllChecked) {
      selectedUsers.clear()
      this.setState({ selectedUsers, isAllChecked: false })
    } else {
      this.filterUsers.forEach(user => {
        selectedUsers.add(user.id)
        this.setState({ selectedUsers, isAllChecked: true })
      })
    }
  }

  removeGroup = async () => {
    const { selectedUsers } = this.state
    try {
      const usersID = []
      selectedUsers.forEach(user => usersID.push(user))

      const data = {
        employee_id: usersID,
        access_object_id: [],
        group_id: this.props.group.id,
      }
      await this.props.removeGroup(data)
      await this.props.fetchGroups({
        count: SETTINGS_PAGINATION.COUNT_PER_PAGE,
        page: SETTINGS_PAGINATION.PAGE_NUMBER,
      })
      selectedUsers.clear()
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  render() {
    const { group } = this.props
    const {
      searchInputValue,
      selectedUsers,

      isAllChecked,
      isOpenModalAddUsersToGroup,
    } = this.state
    const { access } = store.getState().tokenInfo

    this.filterUsers = group.users.filter(
      user =>
        user.title.toLowerCase().indexOf(searchInputValue.toLowerCase()) !== -1
    )

    return (
      <>
        <div className='modal-overlay'>
          <div className='modal'>
            <div className='modal__header'>
              <p className='modal__title'>Группа {group.title}</p>
              <Button
                className='button--icon'
                icon={true}
                iconPicture={closeBtn}
                action={this.props.closeModal}
              />
            </div>

            <div className='modal__content'>
              <div className='modal__controls'>
                <div className='wrapper-controls'>
                  <Search
                    onChangeSearch={this.onChangeSearch}
                    isLocalSearch={true}>
                    {!!selectedUsers.size && (
                      <div className='btn-group'>
                        <Button
                          title='Удалить из группы'
                          className='btn--link btn--link-black'
                          action={this.removeGroup}
                        />
                      </div>
                    )}
                  </Search>
                </div>
                <Button
                  title='Добавить сотрудника'
                  action={this.changeVisibillityModalAddUsersToGroup}
                />
              </div>
              {!!this.filterUsers.length ? (
                <div className='table-wrapper'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <td className='table__checkbox'>
                          <input
                            type='checkbox'
                            onChange={this.toggleAllUsers}
                            checked={isAllChecked}
                          />
                        </td>
                        <td>Фото</td>
                        <td>Имя</td>
                        <td>Статус</td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.filterUsers.map(user => (
                        <tr key={user.id}>
                          <td className='table__checkbox'>
                            <input
                              type='checkbox'
                              value={user.id}
                              checked={selectedUsers.has(user.id)}
                              onChange={this.toggleUser}
                            />
                          </td>
                          <td className='table__photo'>
                            <div
                              className='wrapper-photo'
                              style={{
                                backgroundImage: `url(${
                                  user.photo
                                    ? CONFIG_BASE_URL +
                                      `${user.photo.url_path}?token=${access}`
                                    : noImage
                                }`,
                              }}></div>
                          </td>
                          <td className='table__name'>{user.title}</td>
                          <td>{user.is_active ? 'Активен' : 'Неактивен'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className='not-found'>
                  <p>По вашему запросу ничего не найдено.</p>
                </div>
              )}
            </div>
          </div>
        </div>
        <style>{`
          .modal .input {
            margin-bottom: 0
          }
        `}</style>

        {isOpenModalAddUsersToGroup && (
          <ModalAddUsersToGroup
            group={group}
            openModalAlert={this.props.openModalAlert}
            closeModal={this.changeVisibillityModalAddUsersToGroup}
          />
        )}
      </>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchGroups: data => dispatch(actions.groups.fetchGroups(data)),
    removeGroup: data => dispatch(actions.groups.removeGroup(data)),
  }
}

export default connect(null, mapDispatchToProps)(ModalGroupInfo)
